'use client';

import { useEffect, useLayoutEffect, useRef } from 'react';
import { usePathname, useRouter } from 'next/navigation';
import gsap from 'gsap';
import { Container, Text, useTranslation } from '@weareconceptstudio/core';

//* Helper's
import { config } from '@/helpers';

//* Components
import Button from '@/components/Button';

//* Style
import Custom404TemplateStyle from './style';

const Custom404Template = () => {
	const { selectedLang } = useTranslation();

	//! Next Navigation
	const router = useRouter();
	const pathname = usePathname();

	//! Check
	useEffect(() => {
		if (!(pathname.replace(selectedLang + '/', '') == '/not-found/')) {
			router.push(`/${selectedLang}/not-found/`) || router.push(`/not-found/`);
		}
	}, [router, pathname, selectedLang]);

	//! Refs
	const errorWrapperRef = useRef(null);
	const contentRef = useRef(null);

	const killRefs = useRef({
		contentFadeIn: null,
	});

	useLayoutEffect(() => {
		const wrapper = errorWrapperRef.current;

		if (!wrapper) return;

		const contentEls = contentRef.current;

		if (contentEls) {
			killRefs.current.contentFadeIn = gsap.to(contentEls, {
				opacity: 1,
				duration: 0.5,
				ease: 'power2.out',
				delay: 0.8,
			});
		}

		return () => {
			Object.values(killRefs.current).forEach((animation) => {
				if (animation?.kill) animation.kill();
			});
		};
	}, []);

	return (
		<Custom404TemplateStyle ref={errorWrapperRef}>
			<Container
				row
				className={'error-container'}
			>
				<div className={`col-4 col-dxl-3 col-m-12`} />

				<div
					ref={contentRef}
					className={`col-4 col-dxl-6 col-m-12 main-wrapper align-center opacity-zero`}
				>
					<div className={`h1-large black-1000 error-text font-neue-thin`}>404</div>

					<Text
						tag={`h1`}
						className={`h5 font-ogg-light black-1000 title`}
						text={'404title'}
					/>

					<Text
						className={'p4 font-neue-light black-900 description'}
						text={'404description'}
					/>

					<Button
						text={config.routes.home.name}
						url={config.routes.home.path}
					/>
				</div>

				<div className={`col-4 col-dxl-3 col-m-12`} />
			</Container>
		</Custom404TemplateStyle>
	);
};

export default Custom404Template;
